import React from 'react';
import {
  render
} from 'react-dom';
import App from "./components/App";
import "./components/Translations/i18n";

render( < App / > , document.querySelector('#root'));
